import { render, staticRenderFns } from "./AssetsCreate.vue?vue&type=template&id=fefac670"
import script from "./AssetsCreate.vue?vue&type=script&lang=js"
export * from "./AssetsCreate.vue?vue&type=script&lang=js"
import style0 from "./AssetsCreate.vue?vue&type=style&index=0&id=fefac670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports